<template>
    <address v-if="address && Object.keys(address).length > 0" class="mb-0">
        <template v-if="address.address">{{ address.address }}<br /></template>
        <template v-else>
            <template v-if="address.line1">{{ address.line1 }}<br /></template>
            <template v-if="address.line2">{{ address.line2 }}<br /></template>
        </template>
        <template v-if="address.zipcode || address.city">{{ address.zipcode }} {{ address.city }}<br /></template>
        <template v-if="address.country">{{ address.country }}</template>
    </address>
</template>

<script>
    export default {
        name: 'Address',
        props: {
            address: {
                type: Object,
                required: true
            }
        }
    }
</script>